import { render } from "./AllInvoice.vue?vue&type=template&id=643ddc58"
import script from "./AllInvoice.vue?vue&type=script&lang=js"
export * from "./AllInvoice.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__